import './OrderButtons.scss'

import React from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { EpisodesOrderTypes, Maybe } from '../../types/generated'

const EpisodeOrderTypes = [
  {
    key: EpisodesOrderTypes.NEWEST,
    text: 'common.newest',
  },
  {
    key: EpisodesOrderTypes.OLDEST,
    text: 'common.oldest',
  },
]

interface Props {
  selectedOrderKey: Maybe<EpisodesOrderTypes>
  onClick: (key: EpisodesOrderTypes) => void
}

export default function OrderButtons({ selectedOrderKey, onClick }: Props) {
  const { t } = useTranslation()

  return (
    <div className="OrderButtons">
      <div className="OrderButtons__wrapper">
        {EpisodeOrderTypes.map(({ key, text }) => (
          <button
            key={key}
            id="ChangeOrder"
            className={classNames({
              'OrderButtons__button--selected': selectedOrderKey === key,
            })}
            onClick={() => {
              onClick(key)
            }}
          >
            {t(text)}
          </button>
        ))}
      </div>
    </div>
  )
}
